module.exports = __webpack_public_path__ + "static/media/Peter Levin.447bdeac.png";